import React from 'react';
import Select, { MultiValue } from 'react-select';

interface opcion {
  value: string;
  label: string;
}

interface ComboBoxProps {
  name: string;
  placeHolder: string;
  options: opcion[];
  onChange: (selected: MultiValue<opcion> | null) => void;
  default : MultiValue<opcion>
}

const SelectMultiple: React.FC<ComboBoxProps> = (props) => {
  return (
    <Select
      options={props.options}
      onChange={props.onChange}
      placeholder={props.placeHolder}
      name={props.name}
      isMulti
      defaultValue={props.default}
    />
  );
};

export default SelectMultiple;